import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { Container, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react';
import { useFormik } from 'formik'
import { toast } from 'react-toastify';
import CustomerGroupsFormContentView from './Includes/CustomerGroupsFormContentView'
import { getCustomerGroupDetails, cancelGetCustomerGroupDetailsApi, editCustomerGroup } from 'utlis/Apis/Customers_API'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import { editFormValidationSchema, initialEditFormValues } from './FormHelper';
import { ERROR_WHILE_GETTING_CUSTOMERGROUP_DETAILS } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages';
import { CUSTOMERGROUP_UPDATED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_UPDATING_CUSTOMERGROUP } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';

function EditCustomerGroup(props) {
    const submitButtonRef = useRef(null)

    const [editButtonDisable, setEditButtonDisable] = useState(false)
    const [editButtonLoading, setEditButtonLoading] = useState(false)
    const [customerGroup, setCustomerGroup] = useState({})


    const setFormData = (customerData) => {
        setCustomerGroup(customerData)
    }
    useEffect(() => {
        const customerGroupId = props.match.params.id ?? ""
        getCustomerGroupDetails(props.currentUser.userToken, customerGroupId).then(res => {
            const customerData = res.data
            if (customerData.success) {
                setFormData(customerData.data)
            }
            if (customerData.error) {
                console.log(ERROR_WHILE_GETTING_CUSTOMERGROUP_DETAILS, res)
                toast.dismiss();
                toast.error(ERROR_WHILE_GETTING_CUSTOMERGROUP_DETAILS, {
                    autoClose: 3000,
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCustomerDetails `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })

        return () => {
            cancelGetCustomerGroupDetailsApi()
        }
        // }
    }, [props.match.params.id, props.location.state, props.currentUser.userToken])



    const getHTML_editorResult = (data) => {
        formik.setFieldValue("customergroupDescription", data)
    }

    const onCustomerGroupFormSubmit = values => {
        if (values) {
            setGlobalLoading(true)
            setGlobalLoading(true)
            setEditButtonDisable(true)
            setEditButtonLoading(true)
            editCustomerGroup(props.currentUser.userToken, values).then(res => {
                setGlobalLoading(false)
                setGlobalLoading(false)
                setEditButtonDisable(false)
                setEditButtonLoading(false)
                const addingCustomerGroup = res.data
                if (addingCustomerGroup.success) {
                    onSuccess(addingCustomerGroup.data)
                }
                if (addingCustomerGroup.error) {
                    onError(res)
                }
            }).catch(err => {
                setEditButtonLoading(false)
                console.log(`${ERROR_WHILE__NAME} getEmailEvents `, err.message)
                onCatch()
            })
        }
    }
    const onError = (res) => {
        setEditButtonLoading(false)
        console.log(ERROR_WHILE_UPDATING_CUSTOMERGROUP, res)
        toast.dismiss();
        toast.error(ERROR_WHILE_UPDATING_CUSTOMERGROUP, {
            autoClose: 3000,
        })
    }
    const onCatch = () => {
        toast.dismiss();
        toast.error(UNKNOWN_ERROR_OCCURED, {
            autoClose: 2500,
            onClose: () => {
                setEditButtonLoading(false)
                setGlobalLoading(false)

            }
        })

    }
    const onSuccess = () => {
        setEditButtonLoading(true)
        window.scrollTo(0, 0)
        toast.dismiss();
        setEditButtonLoading(false)
        toast.success(CUSTOMERGROUP_UPDATED_SUCCESSFULLY, {
            autoClose: 2000,
            onClose: () => { }
        })
    }

    const formik = useFormik({
        initialValues: initialEditFormValues(customerGroup),
        validationSchema: editFormValidationSchema,
        onSubmit: onCustomerGroupFormSubmit,
        enableReinitialize: true
    })

    const handleFormSubmission = (ev) => {
        ev.preventDefault()
        submitButtonRef.current.click()
    }

    return (
        <section id="app-emails__edit-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-emails__edit-details">
                    <div className="back-button-wrapper mb-2">
                        <Link to="/customers/groups" className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                            <FeatherIcon
                                icon="arrow-left"
                                size="14"
                                className="icon me-1" />
                            <span>Back to CustomerGroups</span>
                        </Link>
                    </div>

                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Edit CustomerGroup</p>
                        <p className="app-desc">
                        </p>
                    </div>
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        <div className="app-content-container">
                            <CustomerGroupsFormContentView
                                formik={formik}

                                //emailEvents={emailEvents}

                                getHTML_editorResult={getHTML_editorResult}
                            />

                            <div className={`app-card page-bottom-action-btns ${props.sideBarVisibility ? "" : "sidebar-expanded"}`}>
                                <div className="app-card-content bg-white border-top st-border-light d-flex align-items-center justify-content-end">
                                    <Link to="/customers/groups" className="st-btn st-btn-link no-min-width d-flex align-items-center justify-content-center me-1">
                                        Cancel
                                    </Link>
                                    <button
                                        type="submit"
                                        className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(editButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                        disabled={editButtonDisable || Object.keys(formik.errors).length}
                                        onClick={handleFormSubmission}>
                                        {
                                            editButtonLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                <span>Save Changes</span>
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
                    </form>

                </div>
            </Container>
        </section>
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditCustomerGroup)